export default __webpack_public_path__ + "static/media/cover_20231024_032.1b87e266.jpg";